"use client"

import Image from "next/image"
import Link from "next/link"
import { useSession, signOut } from "@/lib/instantdb/session"
import { Button } from "@/components/ui/button"
import { LogOut, Mail } from "lucide-react"

interface LogoHeaderProps {
  showEmail?: boolean
  showLogout?: boolean
  className?: string
}

export function LogoHeader({ showEmail = false, showLogout = false, className = "" }: LogoHeaderProps) {
  const { data: session } = useSession()

  return (
    <header className={`flex items-center justify-between p-4 md:p-6 ${className}`}>
      <Link href="/" className="flex items-center gap-3">
        <div className="relative flex h-12 w-12 flex-shrink-0 items-center justify-center md:h-14 md:w-14">
          <Image
            src="/brand/shapp-dragon.png"
            alt="W'SHU Empire Logo"
            width={56}
            height={56}
            sizes="56px"
            priority
            className="object-contain drop-shadow-[0_8px_16px_rgba(0,0,0,0.25)]"
            style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
          />
        </div>
        <span className="text-xl font-bold md:text-2xl">SHAPP</span>
      </Link>

      <div className="flex items-center gap-4">
        {showEmail && session?.user?.email && (
          <div className="hidden items-center gap-2 text-sm text-muted-foreground md:flex">
            <Mail className="h-4 w-4" />
            <span>{session.user.email}</span>
          </div>
        )}
        {showLogout && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => signOut({ redirect: true })}
            className="gap-2"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden md:inline">Logout</span>
          </Button>
        )}
      </div>
    </header>
  )
}

